import { useState } from "react";
import { orderSetCoupone } from "../../../api/couponeService";
import { NotificationManager } from "react-notifications";
export default function Coupone(props) {
  const { refetch, loader } = props;

  const [mobileHide, setMobileHide] = useState(true);
  const [code, setCode] = useState("");

  const throttle = (func, delay) => {
    let lastCallTime = 0;
    return (...args) => {
      const now = new Date().getTime();
      if (now - lastCallTime < delay) {
        return;
      }
      lastCallTime = now;
      func(...args);
    };
  };

  const handleInputChange = (event) => {
    setCode(event.target.value);
  };

  const handleCodeChange = throttle(async (event) => {
    event.preventDefault();

    loader();
    const { data } = await orderSetCoupone(
      {
        coupon: code,
      },
      (error) => {
        loader(false);
        NotificationManager.error(error.response.data.message, "Error");
      }
    );

    if (!data.status) {
      NotificationManager.error(data.response, "Error");
      loader(false);
      return;
    }
    NotificationManager.success(data.response);
    refetch();
    loader(false);
  }, 1400);

  return (
    <>
      <p className="text-lg text-[#5F6E79] text-[18px] font-semibold pb-3 pt-6 flex items-center justify-between">
        Discount code <span className="md:hidden" onClick={()=>{setMobileHide(!mobileHide)}}>
        {!mobileHide ?         <svg  className="rotate-180"  width="20" height="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="CaretDown">
        <g id="CaretDown_2">
        <path id="Vector" d="M9.75 4.5L6 8.25L2.25 4.5" stroke="#5F6E79" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        </g>
        </svg>:<svg width="20" height="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="CaretDown">
        <g id="CaretDown_2">
        <path id="Vector" d="M9.75 4.5L6 8.25L2.25 4.5" stroke="#5F6E79" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        </g>
        </svg>}
        </span>
      </p>
      <form className= {`flex-row flex w-full pb-4 ${mobileHide ? "hidden md:flex" : " "}`}  onSubmit={handleCodeChange}>
        <input
          className="h-10 w-full rounded-l outline-none border-r-0 border border-slate-400 pl-3"
          placeholder="Enter your code"
          value={code}
          onChange={handleInputChange}
        />
        <button className="bg-[#5F6E79] hover:bg-slate-500  rounded-r h-10 text-white px-9 flex items-center">
          Apply
        </button>
      </form>
    </>
  );
}
